const config = {
    // apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "http://localhost:8080",
    apiBaseUrl: "",
    cognito: {
        region: "us-east-1",
        userPoolId: "us-east-1_R1ZZQols8",
        userPoolClientId: "4293tfi0558rqflnndgjiaqgjv",
        domain: "us-east-1r1zzqols8.auth.us-east-1.amazoncognito.com",
        scopes: ['email', 'openid', 'profile'],
        redirectSignIn: [`${window.location.origin}/`],
        redirectSignOut: [`${window.location.origin}/`],
        responseType: 'code'
    }
};

export default config;
